import React, { useState } from 'react';

import LegalContent from '../../LegalModal/Content';
import { BackNavigate } from '../Components/BackNavigate';

import * as Layout from '../styled';
import * as Styled from './styled';

import { INDEX_PATH } from 'utils/routes';

const LegalTerms = ({ active, readOnly, onNext }) => {
  const [loading, setLoading] = useState(false);

  const onSubmitHandle = () => {
    if (!onNext)
      return;

    setLoading(true);

    // No rush, take is slow, :D
    setTimeout(() => {
      onNext();
      setLoading(false);
    }, 350);
  }

  if (!active)
    return null;

  return (
    <Layout.Screen $terms>
      <BackNavigate to={INDEX_PATH} alternative />

      <Styled.LegalWrapper>
        <LegalContent loading={loading} readOnly={readOnly} onSubmit={onSubmitHandle} />
      </Styled.LegalWrapper>
    </Layout.Screen>
  );
}

export default LegalTerms;
